// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import {
  type AIPromptRequest,
  ClearAIPromptRequest,
  RequestAIPrompt,
} from '@actions/aiSession';

export interface AISessionState {
  /** Prompt the AI panel should open a fresh conversation on; null when idle. */
  requestedPrompt: AIPromptRequest | null;
}

const initialState: AISessionState = {
  requestedPrompt: null,
};

export default handleActions<AISessionState, AIPromptRequest | void>(
  {
    [RequestAIPrompt.toString()]: (
      _: AISessionState,
      { payload }: Action<AIPromptRequest>,
    ): AISessionState => ({ requestedPrompt: payload }),
    [ClearAIPromptRequest.toString()]: (): AISessionState => initialState,
  },
  initialState,
);
